/* eslint react/prop-types: 0 */
/* eslint react/no-multi-comp: 0 */
/* eslint react/display-name: 0 */
import React from 'react';
import { FormattedNumber } from 'react-intl';
import NumericInput from '../common/NumericInput';
import { dataIndexedPerDay, totalDataPerDay } from '../../utils/statsUtils';


const fields = [
  {
    flex: 10,
    label: 'Configured Item',
    renderInput: ({ props, defaultValues, tabIndex, onChange }) => {
      const { excluded, configuredItem } = props;

      return (
        <input
          disabled={excluded}
          type='text'
          name='description'
          className='form-control'
          placeholder={configuredItem.description}
          defaultValue={defaultValues.description}
          maxLength='120'
          tabIndex={tabIndex}
          onChange={onChange}
        />
      );
    }
  },
  {
    flex: 3,
    label: 'Total Items',
    renderInput: ({ props, defaultValues, tabIndex, onChange }) => {
      return (
        <NumericInput
          disabled={props.excluded}
          min={0}
          max={500000}
          step={1}
          name='totalItems'
          className='form-control'
          placeholder={0}
          value={defaultValues.totalItems}
          tabIndex={tabIndex}
          onChange={onChange}
          decimalScale={0}
        />
      );
    }
  },
  {
    flex: 6,
    label: 'Estimated Log Size',
    isHidden: (props) => props.canEditEstimatedLogSize,
    renderInput: ({ props, defaultValues, tabIndex, onChange }) => {
      return (
        <div className='configured-item-form__field-with-suffix'>
          <div className='configured-item-form__field-input'>
            <NumericInput
              disabled={props.excluded}
              min={0}
              max={2147483600}
              step={1}
              name='estimatedLogSize'
              className='form-control'
              placeholder={0}
              value={defaultValues.estimatedLogSize}
              tabIndex={tabIndex}
              onChange={onChange}
              decimalScale={2}
            />
          </div>
          <div className='configured-item-form__field-suffix'>
            MB/day<br />per item
          </div>
        </div>
      );
    }
  },
  {
    flex: 4,
    label: 'Total Daily',
    renderInput: ({ defaultValues }) => {
      return (
        <div className='data-per-day'>
          <span className='data-per-day__value'>
            <FormattedNumber value={totalDataPerDay(defaultValues)} maximumFractionDigits={1} />
            <span className='units'> GB/day</span>
          </span>
        </div>
      );
    }
  },
  {
    flex: 4,
    label: '% Items Indexed',
    isHidden: (props) => props.canEditPercentItemsIndexed,
    tooltip: 'Percentage of Configuration Items being Indexed',
    renderInput: ({ props, defaultValues, tabIndex, onChange }) => {
      return (
        <div className='configured-item-form__field-with-suffix'>
          <div className='configured-item-form__field-input'>
            <NumericInput
              disabled={props.excluded}
              min={0}
              max={100}
              step={1}
              name='indexed'
              className='form-control percent'
              placeholder={0}
              value={defaultValues.indexed}
              tabIndex={tabIndex}
              onChange={onChange}
            />
          </div>
          <div className='configured-item-form__field-suffix'>
            %
          </div>
        </div>
      );
    }
  },
  {
    flex: 4,
    label: '% DS Indexed',
    isHidden: (props) => props.canEditPercentDataSourcesIndexed,
    tooltip: 'Percentage of Data Sources being Indexed, for the Indexed Configuration Items',
    renderInput: ({ props, defaultValues, tabIndex, onChange }) => {
      return (
        <div className='configured-item-form__field-with-suffix'>
          <div className='configured-item-form__field-input'>
            <NumericInput
              disabled={props.excluded}
              min={0}
              max={100}
              step={1}
              name='percentDataSourcesIndexed'
              className='form-control percent'
              placeholder={0}
              value={defaultValues.percentDataSourcesIndexed}
              tabIndex={tabIndex}
              onChange={onChange} />
          </div>
          <div className='configured-item-form__field-suffix'>
            %
          </div>
        </div>
      );
    }
  },
  {
    flex: 4,
    label: 'Cisco Device %',
    tooltip: 'Percentage of this data source ingested from Cisco devices',
    renderInput: ({ props, defaultValues, tabIndex, onChange }) => {
      return (
        <div className='configured-item-form__field-with-suffix'>
          <div className='configured-item-form__field-input'>
            <NumericInput
              disabled={props.excluded}
              min={0}
              max={100}
              step={1}
              name='ciscoPercent'
              className='form-control percent'
              placeholder={0}
              value={defaultValues.ciscoPercent}
              tabIndex={tabIndex}
              onChange={onChange}
            />
          </div>
          <div className='configured-item-form__field-suffix'>
            %
          </div>
        </div>
      );
    }
  },
  {
    flex: 4,
    label: 'Total Indexed',
    isHidden: (props) => props.canViewTotalIndexed,
    renderInput: ({ defaultValues }) => {
      return (
        <div className='data-per-day'>
          <span className='data-per-day__value'>
            <FormattedNumber value={dataIndexedPerDay(defaultValues)} maximumFractionDigits={1} />
            <span className='units'> GB/day</span>
          </span>
        </div>
      );
    }
  }
];

export default fields;
export const getVisibleConfiguredItemFormFields = props => fields.filter(field => field.isHidden ? field.isHidden(props) : true);



// WEBPACK FOOTER //
// ./src/components/sources/configuredItemFormFields.js